import * as React from "react";
const SvgUpload20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 18,
        fill: "black",
        viewBox: "0 0 16 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8.707 1.293 8 .586l-.707.707-4 4L2.586 6 4 7.414l.707-.707L7 4.414V14h2V4.414l2.293 2.293.707.707L13.414 6l-.707-.707-4-4ZM2 11v5h12v-5h2v7H0v-7h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgUpload20Px;
